// extracted by mini-css-extract-plugin
export default {"header":"_18u9wvwk","footer":"_3_zLMPnb"};